import React from 'react'
import Dialog from '../../../../dialog/Dialog'
import FormGranularStepsPreview from '../FormPreview/FormGranularStepsPreview'

const PreviewLearningContinuum = ({ onClose, open, formData }) => {
  return (
    <Dialog
      id='learning-continua-preview'
      show={open}
      title='Learning continua preview'
      onClose={onClose}
      onCloseHeader={true}
      maxWidth='lg'
    >
      <div className='max-h-screen-modal-content overflow-auto'>
        <FormGranularStepsPreview lcs={[formData]} />
      </div>
    </Dialog>
  )
}

export default PreviewLearningContinuum
